import {https, httpsFile} from './http.js';

export function show(id){
    return httpsFile().get(`pr-header-discounts/${id}`)
}

export function update(id,data){
    return httpsFile().post(`pr-header-discounts/${id}`,data)
}